import { useProgramContextWithWorkflow } from '@rhg/hooks/use-program-context/with-workflow';
import { useProvidedProgramContext } from '../';

export function useProvidedProgramContextWithWorkflow() {
    const {
        program,
        programMetadata,
        packProgram,
        packClass,
        recommendation,
        isFetched,
        _workflow,
    } = useProvidedProgramContext();
    return useProgramContextWithWorkflow({
        program,
        programMetadata,
        packProgram,
        packClass,
        recommendation,
        isFetched,
        workflow: _workflow,
    });
}
